/* image banner section - custom button positioning */
var oImageBannerSectionCusPos = document.querySelectorAll(
    ".section--image.custom-position .hero__content"
  ), infiniteCollection;
  
  function init() {
    if (oImageBannerSectionCusPos.length > 0) {
      setImageBannersCustomPosition();
      window.addEventListener("resize", setImageBannersCustomPosition);
    }
    setInfiniteCollectionScroll();
  }
  
  function setImageBannersCustomPosition() {
    for (var i = 0; i < oImageBannerSectionCusPos.length; i++) {
      
      //var styleBottom = parseFloat(getComputedStyle(oImageBannerSectionCusPos[i]).getPropertyValue("bottom").match(/[\d\.]+/)),
      var styleBottom = oImageBannerSectionCusPos[i].parentElement.offsetHeight * (oImageBannerSectionCusPos[i].getAttribute("set-pos-bot") / 100),
          parentHeight = oImageBannerSectionCusPos[i].parentElement.offsetHeight,
          spaceRemaining = parentHeight - styleBottom - oImageBannerSectionCusPos[i].offsetHeight;
  
      if (spaceRemaining <= 0) {
        oImageBannerSectionCusPos[i].style.bottom = (100 - ((oImageBannerSectionCusPos[i].offsetHeight / oImageBannerSectionCusPos[i].parentElement.offsetHeight) * 100)) + "%";
      } else {
        oImageBannerSectionCusPos[i].style.bottom = "";
      }
    }
  }
  
  document.addEventListener("DOMContentLoaded", init);

/* Collection page - infinite scroll */
var urlAddressOld = window.location.href;
if ('navigation' in window) {
  window.navigation.addEventListener("navigate", function () {
    setTimeout(setInfiniteCollectionScroll, 2000);
  });
} else {
  // Safari, Firefox
  setTimeout(setInfiniteCollectionScroll, 2000);
}

function safariCheckUrlUpdated() {
  if (window.location.href != urlAddressOld) {
    setInfiniteCollectionScroll();
    urlAddressOld = window.location.href;
  }
  setTimeout(safariCheckUrlUpdated, 2000);
}

function setInfiniteCollectionScroll() {
  if(MeetAjaxForProduct != null) {
    infiniteCollection = '';
    infiniteCollection = new MeetAjaxForProduct({
      container: '#collection-grid',
      pagination: '.meet_infinite_next',
    });
  } else {
    setTimeout(setInfiniteCollectionScroll,200);
  }
}

/* product cards - swatches on hover update card to the swatches product info. All locations */
function swatchHoverEnterProductUpdate() {
  var oProductCard = document.querySelector('product-grid-item[data-item-id="' + this.getAttribute('data-swatch-product-card-id') + '"]'),
      oTitle = oProductCard.querySelector('.product__grid__title'),
      oPrice = oProductCard.querySelector('.product__grid__price .price'),
      oPriceCompare = oProductCard.querySelector('.product__grid__price .compare-at'),
      oActiveProductImage = oProductCard.querySelector('[data-swatch-link-id="' + this.getAttribute('data-swatch-product-id') + '"]');
  
  oTitle.innerText = this.getAttribute('data-swatch-product-title');
  oPrice.innerText = this.getAttribute('data-swatch-product-price');
  if(oPriceCompare) oPriceCompare.innerText = this.getAttribute('data-swatch-product-compare-price');
  oActiveProductImage.classList.add('is-active');
}

function swatchHoverLeaveProductUpdate() {
  var oProductCard = document.querySelector('product-grid-item[data-item-id="' + this.getAttribute('data-swatch-product-card-id') + '"]'),
      oTitle = oProductCard.querySelector('.product__grid__title'),
      oPrice = oProductCard.querySelector('.product__grid__price .price'),
      oPriceCompare = oProductCard.querySelector('.product__grid__price .compare-at'),
      oActiveProductImage = oProductCard.querySelector('[data-swatch-link-id="' + this.getAttribute('data-swatch-product-id') + '"]');

  oTitle.innerText = oTitle.getAttribute('data-main-product-title');
  oPrice.innerText = oPrice.getAttribute('data-main-product-price');
  if(oPriceCompare) oPriceCompare.innerHTML = oPriceCompare.getAttribute('data-main-product-compare-price');
  oActiveProductImage.classList.remove('is-active');
}

// create custom event for when the url changes
(function() {
  const originalPushState = history.pushState;
  const originalReplaceState = history.replaceState;

  // Override pushState to dispatch our custom event
  history.pushState = function(state) {
    const result = originalPushState.apply(this, arguments); // Call the original method
    window.dispatchEvent(new Event('urlchange')); // Dispatch custom event
    return result;
  };

  // Override replaceState to dispatch our custom event
  history.replaceState = function(state) {
    const result = originalReplaceState.apply(this, arguments); // Call the original method
    window.dispatchEvent(new Event('urlchange')); // Dispatch custom event
    return result;
  };

  // Listen for the native popstate event (for back/forward button presses)
  window.addEventListener('popstate', function() {
    window.dispatchEvent(new Event('urlchange')); // Dispatch custom event
  });
})();

function setProductCardSwatchesEvents() {

  var oProductCardSwatches = document.querySelectorAll('product-grid-item .product-link-swatches a');
    for (let i = 0; i < oProductCardSwatches.length; i++) {
      oProductCardSwatches[i].addEventListener('mouseenter', swatchHoverEnterProductUpdate);
      oProductCardSwatches[i].addEventListener('mouseleave', swatchHoverLeaveProductUpdate);
    }
}

// Dom loaded
window.addEventListener('DOMContentLoaded', function() {
  setTimeout(setProductCardSwatchesEvents, 2000);
});
// url changed
window.addEventListener('urlchange', function() {
  setTimeout(setProductCardSwatchesEvents, 1000);
});